import { ModuleFE_ProviderChatInteraction } from './ModuleFE_ProviderChatInteraction.js';
export const ModulePack_ProviderChatInteractionDB = [ModuleFE_ProviderChatInteraction];
//# sourceMappingURL=module-pack.js.map